import * as THREE from 'three'
import assetsLoader from '@/plugins/assets-loader'

function generateModel() {
  const gradientMap = assetsLoader.get('threeTone').subject

  const model = assetsLoader.get('grenade').subject.scene.clone()
  model.traverse((child) => {
    if (child.name.includes('body') || child.name.includes('grain')) {
      child.material = new THREE.MeshToonMaterial({
        color: 0xf6474e,
        gradientMap,
      })
    }

    if (child.name.includes('inside')) {
      child.material = new THREE.MeshToonMaterial({
        color: 0xeee1cb,
        gradientMap,
      })
    }

    if (child.name.includes('tail')) {
      child.material = new THREE.MeshToonMaterial({
        color: 0xffdd01,
        gradientMap,
      })
    }

    if (child.name.includes('outline')) {
      child.material = new THREE.MeshBasicMaterial({
        color: 0x000000,
      })
    }
  })

  return model
}

export default class Grenade extends THREE.Object3D {
  constructor() {
    super()
    const model = generateModel()

    this.add(model)
  }
}
